import { render } from "./AboutCBC.vue?vue&type=template&id=60476202&scoped=true"
import script from "./AboutCBC.vue?vue&type=script&lang=js"
export * from "./AboutCBC.vue?vue&type=script&lang=js"

import "./AboutCBC.vue?vue&type=style&index=0&id=60476202&scoped=true&lang=less"
import "./AboutCBC.vue?vue&type=style&index=1&id=60476202&lang=less"

import exportComponent from "D:\\workCode\\cbc\\website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60476202"]])

export default __exports__